// Create new item component with pulse effect
import React, { useEffect, useRef } from "react";
import gsap from "gsap";

export const NewItem: React.FC = () => {
  const pulseRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!pulseRef.current) return undefined;

    gsap.set(pulseRef.current, { scale: 0.5, opacity: 0.8 });

    gsap.to(pulseRef.current, {
      duration: 1.5,
      scale: 2.5,
      opacity: 0,
      ease: "expo.out",
      repeat: -1,
      repeatDelay: 0.3,
    });
  }, []);

  return (
    <span className="c-new-item__wrapper">
      <span className="c-new-item"></span>
      <span className="c-new-item__pulse" ref={pulseRef}></span>
    </span>
  );
};
